import React from 'react';

/**
 * SchemaMarkup component for injecting JSON-LD structured data into the page.
 * @param {Object} schema - The JSON-LD schema object.
 */
const SchemaMarkup = ({ schema }) => {
  if (!schema) return null;

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

export default SchemaMarkup;
